module.exports = __webpack_public_path__ + "08_mole.37f21264.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/08_mole.png
// module id = g7UA
// module chunks = 0